class LocalizationFormComponent extends HTMLElement {
  constructor() {
    super();
    this.form = null;
    this.languageInput = null;
    this.countryInput = null;
    this.countryInputItems = null;
  }

  connectedCallback() {
    // On utilise l'ID exceptionnellement à la place des data-ref car c'est une balise {% form %}
    this.form = this.querySelector('#LocalizationForm');
    this.languageInput = this.querySelector('[data-ref="language-input"]');
    this.countryInput = this.querySelector('[data-ref="country-input"]');
    this.countryInputItems = this.querySelectorAll('[data-ref="country-input-item"]');
    this.siteLanguageInput = this.querySelector('[data-ref="site-language-input"]');
    this.siteLanguageItems = this.querySelectorAll('[data-ref="site-language-item"]');

    // Maison Scarlett : langues actives de tous les marchés (une langue = un domaine)
    this.siteLanguageItems.forEach((siteLanguageItem) => {
      siteLanguageItem.addEventListener('click', this.selectSiteLanguage);
      siteLanguageItem.addEventListener('keydown', this.onSiteLanguageKeydown);
    });

    // On écoute les changements de pays
    this.countryInputItems.forEach((countryInputItem) => {
      countryInputItem.addEventListener('click', (event) => {
        this.selectCountry(countryInputItem.dataset.value, event);
      });
    });

    // On écoute les changements de langue
    this.languageInput?.addEventListener('change', (event) => {
      this.changeLanguage(event);
    });
  }

  disconnectedCallback() {
    this.siteLanguageItems?.forEach((siteLanguageItem) => {
      siteLanguageItem.removeEventListener('click', this.selectSiteLanguage);
      siteLanguageItem.removeEventListener('keydown', this.onSiteLanguageKeydown);
    });

    this.countryInputItems.forEach((countryInputItem) => {
      countryInputItem.removeEventListener('click', (event) => {
        this.selectCountry(countryInputItem.dataset.value, event);
      });
    });

    this.languageInput?.removeEventListener('change', (event) => {
      this.changeLanguage(event);
    });
  }

  selectCountry = (countryName, event) => {
    event.preventDefault();

    this.countryInput.value = countryName;
    this.form?.submit();
  };

  onSiteLanguageKeydown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') this.selectSiteLanguage(event);
  };

  // Va sur la même page dans la langue choisie : URL lue dans les balises hreflang natives de Shopify
  // (slugs traduits, bon domaine). Sans balise correspondante, on soumet le formulaire de localisation.
  selectSiteLanguage = (event) => {
    event.preventDefault();

    const { language, country } = event.currentTarget.dataset;
    if (!language || language === this.siteLanguageInput?.defaultValue) return;

    const alternate =
      document.querySelector(`link[rel="alternate"][hreflang="${language}"]`) ||
      document.querySelector(`link[rel="alternate"][hreflang="${language}-${country}"]`) ||
      document.querySelector(`link[rel="alternate"][hreflang^="${language}-"]`);

    if (alternate?.href) {
      window.location.href = alternate.href;
      return;
    }

    if (country && this.countryInput) this.countryInput.value = country;
    if (this.siteLanguageInput) this.siteLanguageInput.value = language;
    this.form?.submit();
  };

  changeLanguage(event) {
    const value = event.target instanceof HTMLSelectElement ? event.target.value : null;

    if (value) {
      this.languageInput.value = value;
      this.form?.submit();
    }
  }
}

if (!customElements.get('localization-form-component')) {
  customElements.define('localization-form-component', LocalizationFormComponent);
}
